/** About / Contact / DMCA 站务页正文（独立模块，便于扩写） */

export const aboutPage = {
	title: 'About GBWhatPro.org',
	breadcrumb: [{ label: 'Home', href: '/' }, { label: 'About' }],
	sections: [
		{
			paragraphs: [
				'GBWhatPro.org is an independent English help site for Android users researching GB WhatsApp Pro. We publish installation walkthroughs, feature explainers, update notes, safety context, and troubleshooting articles written for search intent—not as official product documentation.',
			],
		},
		{
			h2: 'What we publish',
			paragraphs: [
				'Our content is organized around real tasks: downloading a verified APK, installing without losing chats, updating manually, understanding ban and privacy trade-offs, and fixing common errors. Hub pages link to deeper guides so you can follow one problem at a time instead of reading a single long FAQ.',
			],
			list: [
				'Core guides under Features, Installation, Update, Safety, and Help',
				'A structured blog grouped by account security, troubleshooting, updates, backup, and settings',
				'Download information with file details when we can verify them',
			],
		},
		{
			h2: 'What we are not',
			paragraphs: [
				'We are not WhatsApp LLC, Meta Platforms, Inc., or the developers of GB WhatsApp Pro. We do not operate WhatsApp servers, issue verification codes, or reset banned accounts. Trademarks belong to their owners; use of names on this site is for descriptive purposes only.',
				'Nothing here is legal, medical, or financial advice. If you rely on WhatsApp for regulated work, healthcare coordination, or payments, evaluate risks with your own policies before using any modified client.',
			],
		},
		{
			h2: 'How we handle downloads and versions',
			paragraphs: [
				'When we list an APK, we aim to show version labels, approximate size, and Android requirements that match what we can verify. Builds change frequently; always compare the file you downloaded with the details on our <a href="/download/">download page</a> before installing.',
				'We do not claim that every feature mentioned in guides exists in every APK line. Menu labels differ between releases—confirm toggles inside your installed app.',
			],
		},
		{
			h2: 'Editorial standards',
			paragraphs: [
				'Articles are written to be useful without hype: we explain limits, link related guides, and avoid guaranteed “anti-ban” language. When WhatsApp policy or Android behavior changes, we update pages in batches rather than leaving outdated steps online silently.',
				'If you spot a factual error, out-of-date version string, or broken instruction, email us via the <a href="/contact/">contact page</a>. We prioritize fixes that affect install safety or account access.',
			],
		},
		{
			h2: 'Affiliation and reference sites',
			paragraphs: [
				'GBWhatPro.org is a standalone domain. We may reference community resources or other GB-themed sites for context, but we do not imply endorsement by Meta or by other publishers unless explicitly stated.',
			],
		},
	],
}

export const contactPage = {
	title: 'Contact',
	breadcrumb: [{ label: 'Home', href: '/' }, { label: 'Contact' }],
	sections: [
		{
			paragraphs: [
				'Use the email below for site-related messages. We cannot access your WhatsApp account, lift restrictions, or send SMS verification codes on your behalf.',
			],
		},
		{
			h2: 'Email',
			paragraphs: ['For content corrections, privacy questions, or copyright notices:'],
			email: true,
		},
		{
			h2: 'What we can help with',
			list: [
				'Correcting factual errors in guides (version numbers, broken links, unclear steps)',
				'Privacy policy questions about GBWhatPro.org itself—not WhatsApp account data',
				'DMCA and other copyright reports about material hosted on this domain',
				'Business or partnership inquiries related to GBWhatPro.org content',
			],
		},
		{
			h2: 'What we cannot do',
			list: [
				'Restore banned or locked WhatsApp numbers',
				'Provide APK files by email or custom builds',
				'Guarantee that a specific GB WhatsApp Pro version will work on your device',
				'Offer real-time chat support or phone support',
			],
		},
		{
			h2: 'Response time',
			paragraphs: [
				'We read messages in business-day order. Simple typo fixes may be handled quickly; complex technical investigations can take longer. Include the page URL, your Android version, and the GB build version when reporting a guide issue.',
			],
		},
		{
			h2: 'Security reminder',
			paragraphs: [
				'Never send your WhatsApp SMS verification code, two-step PIN, or banking details to anyone claiming to be “GBWhatPro support.” We will never ask for those values.',
			],
		},
	],
}

export const dmcaPage = {
	title: 'DMCA Notice',
	effectiveDate: 'January 2026',
	breadcrumb: [{ label: 'Home', href: '/' }, { label: 'DMCA' }],
	sections: [
		{
			paragraphs: [
				'GBWhatPro.org respects intellectual property rights. If you believe content on this site infringes your copyright, send a notice that includes the information below. Incomplete notices may delay review.',
			],
		},
		{
			h2: 'Required information',
			list: [
				'Identification of the copyrighted work you claim has been infringed',
				'Identification of the material on GBWhatPro.org that you claim is infringing, with enough detail to locate it (URL preferred)',
				'Your contact information: name, mailing address, telephone number, and email',
				'A statement that you have a good-faith belief that use of the material is not authorized by the copyright owner, its agent, or the law',
				'A statement, under penalty of perjury, that the information in the notice is accurate and that you are authorized to act on behalf of the copyright owner',
				'Your physical or electronic signature',
			],
		},
		{
			h2: 'Where to send notices',
			paragraphs: ['Send DMCA notices and counter-notices to:'],
			email: true,
		},
		{
			h2: 'Counter-notification',
			paragraphs: [
				'If you believe material was removed or disabled by mistake or misidentification, you may submit a counter-notification that meets applicable legal requirements, including consent to jurisdiction of the federal court in your district (or where GBWhatPro.org may be found, if outside the U.S.).',
				'We may forward your counter-notification to the original complainant. Restored content may occur after the statutory waiting period where applicable.',
			],
		},
		{
			h2: 'Repeat infringers',
			paragraphs: [
				'We may terminate access for users or contributors who repeatedly infringe copyrights when appropriate under our policies and applicable law.',
			],
		},
		{
			h2: 'Non-DMCA issues',
			paragraphs: [
				'For general content corrections that are not copyright claims, use the <a href="/contact/">contact page</a> instead so we can route your message correctly.',
			],
		},
	],
}
